import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesTestMeetingManage {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
        return webcontext;
    }


    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        if (webContext.ResponseMessage.Success) {
            webContext.Status.Datas.forEach(item => {
                item.a_ZhuangTai = this.formatStatus(item.a_ZhuangTai);
            })
        }

        return webContext;
    }

    private formatStatus(status) {
        let str = '';
        switch (status) {
            case '0':
                str = '审核中'; break;
            case '1':
                str = '已完成'; break;
            case '2':
                str = '已取消'; break;
            default:
                break;
        }
        return str;

    }

}